import { render, staticRenderFns } from "./releaseNote.vue?vue&type=template&id=67f3eb39"
import script from "./releaseNote.vue?vue&type=script&lang=js"
export * from "./releaseNote.vue?vue&type=script&lang=js"
import style0 from "./releaseNote.vue?vue&type=style&index=0&id=67f3eb39&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports